import Grid from '@mui/material/Grid';
import * as React from 'react';
import { Contact } from '../../../sic-lib/types/Contact';
import MenuAddContactTags from './MenuAddContactTags';
import TagComponent from './TagComponent';

interface Props {
    contact: Contact;
}

export default function ContactTags({ contact }: Props) {
    return (
        <React.Fragment>
            <Grid container direction="row" wrap="wrap" alignItems="center" spacing={1}>
                {contact.tags.map(tag => (
                    <Grid key={tag.tagId} item xs="auto">
                        <TagComponent contactId={contact.contactId} tag={tag} />
                    </Grid>
                ))}
            </Grid>
            <MenuAddContactTags contact={contact} />
        </React.Fragment>
    );
}
